/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BlogManagerEditArticleResponse } from './BlogManagerEditArticleResponse';

export type BlogManagerEditArticleResponseApiRespoonse = {
    data?: BlogManagerEditArticleResponse;
    status?: BlogManagerEditArticleResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace BlogManagerEditArticleResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

